import type { ReactNode } from 'react';

export function PageHeading({
  title,
  description,
  actions,
}: {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <div className="page__head">
      <div>
        <h1 className="page__title">{title}</h1>
        {description !== undefined && <p className="page__desc">{description}</p>}
      </div>
      {actions !== undefined && <div className="inline">{actions}</div>}
    </div>
  );
}
